import React from 'react';
import { Redirect } from 'react-router-dom';
import { EventSettingsContextType, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';
import EventDetails from '../../shared/EventDetails';
import WelcomeBlock from './WelcomeBlock';
import isEnabledRoute from '../../../hooks/use-enabled-route';

const WelcomeWrapper: React.FC = (): JSX.Element | null => {
  const data = useEventSettings() as EventSettingsContextType;

  if (data && !data.welcomeEnabled) {
    const enabledRoute = isEnabledRoute(data?.landingPage);
    return <Redirect to={enabledRoute} />;
  }

  if (data) return (
    <>
      <EventDetails details={data}/>
      <WelcomeBlock {...data}/>
    </>
  );

  return null;
};



export default WelcomeWrapper;
